import { render, staticRenderFns } from "./interview.vue?vue&type=template&id=3a8ac672&scoped=true"
import script from "./interview.vue?vue&type=script&lang=js"
export * from "./interview.vue?vue&type=script&lang=js"
import style0 from "./interview.vue?vue&type=style&index=0&id=3a8ac672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ac672",
  null
  
)

export default component.exports